export default __webpack_public_path__ + "static/media/bounce.fd0513c3.mp3";